import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { FormFieldComponent } from './form-field.component';
import { HierarchyDropdownModule } from 'shared/components/hierarchy-dropdown/hierarchy-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormsModule,
    HierarchyDropdownModule
  ],
  declarations: [
    FormFieldComponent
  ],
  exports: [
    FormFieldComponent
  ]
})
export class FormFieldModule {}
